/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(17);
	module.exports = __webpack_require__(13);


/***/ },
/* 1 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.White = 0;
	exports.Black = 1;
	exports.WIDTH = 8;
	exports.HEIGHT = 8;


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var constantes_1 = __webpack_require__(1);
	exports.types = {};
	function registerPieceType(t) {
	    exports.types[t.key] = t;
	    return t;
	}
	exports.registerPieceType = registerPieceType;
	function getPieceType(key) {
	    return exports.types[key];
	}
	exports.getPieceType = getPieceType;
	function makeMove(x, y, repeat, condition) {
	    if (repeat === void 0) { repeat = 1; }
	    if (condition === void 0) { condition = null; }
	    return { x: x, y: y, repeat: repeat, condition: condition };
	}
	exports.makeMove = makeMove;
	exports.King = registerPieceType({
	    key: 'k',
	    movements: [
	        makeMove(0, 1),
	        makeMove(1, 1),
	        makeMove(-1, 1),
	        makeMove(1, -1),
	        makeMove(-1, -1),
	        makeMove(0, -1),
	        makeMove(1, 0),
	        makeMove(-1, 0),
	    ],
	});
	exports.Queen = registerPieceType({
	    key: 'q',
	    movements: [
	        makeMove(1, 0, 8),
	        makeMove(1, 1, 8),
	        makeMove(1, -1, 8),
	        makeMove(0, 1, 8),
	        makeMove(0, -1, 8),
	        makeMove(-1, 0, 8),
	        makeMove(-1, 1, 8),
	        makeMove(-1, -1, 8),
	    ],
	    canPromote: true,
	});
	exports.Bishop = registerPieceType({
	    key: 'b',
	    movements: [
	        makeMove(1, 1, 8),
	        makeMove(1, -1, 8),
	        makeMove(-1, 1, 8),
	        makeMove(-1, -1, 8),
	    ],
	    canPromote: true,
	});
	exports.Knight = registerPieceType({
	    key: 'n',
	    movements: [
	        makeMove(-1, 2),
	        makeMove(1, 2),
	        makeMove(-1, -2),
	        makeMove(1, -2),
	        makeMove(-2, 1),
	        makeMove(-2, -1),
	        makeMove(2, 1),
	        makeMove(2, -1),
	    ],
	    canPromote: true,
	});
	exports.Rook = registerPieceType({
	    key: 'r',
	    movements: [
	        makeMove(1, 0, 8),
	        makeMove(0, 1, 8),
	        makeMove(0, -1, 8),
	        makeMove(-1, 0, 8),
	    ],
	    canPromote: true,
	});
	var canPawnDoubleMove = function (from) {
	    return from.piece.color === constantes_1.White ? from.y <= 2 : from.y >= 5;
	};
	var pawnMove = function (from, to, repeat, getSquare) {
	    return ((repeat === 0 || (repeat === 1 && canPawnDoubleMove(from))) &&
	        to.piece === null);
	};
	var pawnKill = function (from, to, repeat, getSquare) {
	    return !!to.piece;
	};
	exports.Pawn = registerPieceType({
	    key: '',
	    movements: [
	        makeMove(0, 1, 2, pawnMove),
	        makeMove(1, 1, 1, pawnKill),
	        makeMove(-1, 1, 1, pawnKill),
	    ],
	});


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	!function(global, factory) {
	     true ? factory(exports) : 'function' == typeof define && define.amd ? define([ 'exports' ], factory) : factory(global.preact = global.preact || {});
	}(this, function(exports) {
	    function VNode(nodeName, attributes, children) {
	        this.nodeName = nodeName;
	        this.attributes = attributes;
	        this.children = children;
	        this.key = attributes && attributes.key;
	    }
	    function extend(obj, props) {
	        if (props) for (var i in props) if (void 0 !== props[i]) obj[i] = props[i];
	        return obj;
	    }
	    function clone(obj) {
	        return extend({}, obj);
	    }
	    function delve(obj, key) {
	        for (var p = key.split('.'), i = 0; i < p.length && obj; i++) obj = obj[p[i]];
	        return obj;
	    }
	    function toArray(obj, offset) {
	        return [].slice.call(obj, offset);
	    }
	    function isFunction(obj) {
	        return 'function' == typeof obj;
	    }
	    function isString(obj) {
	        return 'string' == typeof obj;
	    }
	    function empty(x) {
	        return void 0 === x || null === x;
	    }
	    function falsey(value) {
	        return value === !1 || empty(value);
	    }
	    function hashToClassName(c) {
	        var str = '';
	        for (var prop in c) if (c[prop]) {
	            if (str) str += ' ';
	            str += prop;
	        }
	        return str;
	    }
	    function h(nodeName, attributes, firstChild) {
	        var children, arr, lastSimple, len = arguments.length;
	        if (len > 2) {
	            var type = typeof firstChild;
	            if (3 === len && 'object' !== type && 'function' !== type) {
	                if (!falsey(firstChild)) children = [ String(firstChild) ];
	            } else {
	                children = [];
	                for (var i = 2; i < len; i++) {
	                    var _p = arguments[i];
	                    if (!falsey(_p)) {
	                        if (_p.join) arr = _p; else (arr = SHARED_TEMP_ARRAY)[0] = _p;
	                        for (var j = 0; j < arr.length; j++) {
	                            var child = arr[j], simple = !(falsey(child) || isFunction(child) || child instanceof VNode);
	                            if (simple && !isString(child)) child = String(child);
	                            if (simple && lastSimple) children[children.length - 1] += child; else if (!falsey(child)) {
	                                children.push(child);
	                                lastSimple = simple;
	                            }
	                        }
	                    } else ;
	                }
	            }
	        } else if (attributes && attributes.children) return h(nodeName, attributes, attributes.children);
	        if (attributes) {
	            if (attributes.children) delete attributes.children;
	            if (!isFunction(nodeName)) {
	                if ('className' in attributes) {
	                    attributes.class = attributes.className;
	                    delete attributes.className;
	                }
	                lastSimple = attributes.class;
	                if (lastSimple && !isString(lastSimple)) attributes.class = hashToClassName(lastSimple);
	            }
	        }
	        var p = new VNode(nodeName, attributes || void 0, children);
	        if (options.vnode) options.vnode(p);
	        return p;
	    }
	    function cloneElement(vnode, props) {
	        return h(vnode.nodeName, extend(clone(vnode.attributes), props), arguments.length > 2 ? toArray(arguments, 2) : vnode.children);
	    }
	    function createLinkedState(component, key, eventPath) {
	        var path = key.split('.'), p0 = path[0];
	        return function(e) {
	            var _component$setState;
	            var v, i, t = e && e.currentTarget || this, s = component.state, obj = s;
	            if (isString(eventPath)) {
	                v = delve(e, eventPath);
	                if (empty(v) && (t = t._component)) v = delve(t, eventPath);
	            } else v = t.nodeName ? (t.nodeName + t.type).match(/^input(check|rad)/i) ? t.checked : t.value : e;
	            if (isFunction(v)) v = v.call(t);
	            if (path.length > 1) {
	                for (i = 0; i < path.length - 1; i++) obj = obj[path[i]] || (obj[path[i]] = {});
	                obj[path[i]] = v;
	                v = s[p0];
	            }
	            component.setState((_component$setState = {}, _component$setState[p0] = v, _component$setState));
	        };
	    }
	    function enqueueRender(component) {
	        if (1 === items.push(component)) (options.debounceRendering || defer)(rerender);
	    }
	    function rerender() {
	        if (items.length) {
	            var p, currentItems = items;
	            items = itemsOffline;
	            itemsOffline = currentItems;
	            while (p = currentItems.pop()) if (p._dirty) renderComponent(p);
	        }
	    }
	    function isFunctionalComponent(vnode) {
	        var nodeName = vnode && vnode.nodeName;
	        return nodeName && isFunction(nodeName) && !(nodeName.prototype && nodeName.prototype.render);
	    }
	    function buildFunctionalComponent(vnode, context) {
	        return vnode.nodeName(getNodeProps(vnode), context || EMPTY);
	    }
	    function ensureNodeData(node, data) {
	        return node[ATTR_KEY] || (node[ATTR_KEY] = data || {});
	    }
	    function getNodeType(node) {
	        if (node instanceof Text) return 3;
	        if (node instanceof Element) return 1; else return 0;
	    }
	    function removeNode(node) {
	        var p = node.parentNode;
	        if (p) p.removeChild(node);
	    }
	    function setAccessor(node, name, value, old, isSvg) {
	        ensureNodeData(node)[name] = value;
	        if ('key' !== name && 'children' !== name && 'innerHTML' !== name) if ('class' === name && !isSvg) node.className = value || ''; else if ('style' === name) {
	            if (!value || isString(value) || isString(old)) node.style.cssText = value || '';
	            if (value && 'object' == typeof value) {
	                if (!isString(old)) for (var i in old) if (!(i in value)) node.style[i] = '';
	                for (var i in value) node.style[i] = 'number' == typeof value[i] && !NON_DIMENSION_PROPS[i] ? value[i] + 'px' : value[i];
	            }
	        } else if ('dangerouslySetInnerHTML' === name) {
	            if (value) node.innerHTML = value.__html;
	        } else if (name.match(/^on/i)) {
	            var l = node._listeners || (node._listeners = {});
	            name = toLowerCase(name.substring(2));
	            if (value) {
	                if (!l[name]) node.addEventListener(name, eventProxy);
	            } else if (l[name]) node.removeEventListener(name, eventProxy);
	            l[name] = value;
	        } else if ('type' !== name && !isSvg && name in node) {
	            setProperty(node, name, empty(value) ? '' : value);
	            if (falsey(value)) node.removeAttribute(name);
	        } else {
	            var ns = isSvg && name.match(/^xlink\:?(.+)/);
	            if (falsey(value)) if (ns) node.removeAttributeNS('http://www.w3.org/1999/xlink', toLowerCase(ns[1])); else node.removeAttribute(name); else if ('object' != typeof value && !isFunction(value)) if (ns) node.setAttributeNS('http://www.w3.org/1999/xlink', toLowerCase(ns[1]), value); else node.setAttribute(name, value);
	        }
	    }
	    function setProperty(node, name, value) {
	        try {
	            node[name] = value;
	        } catch (e) {}
	    }
	    function eventProxy(e) {
	        return this._listeners[e.type](options.event && options.event(e) || e);
	    }
	    function getRawNodeAttributes(node) {
	        var attrs = {};
	        for (var i = node.attributes.length; i--; ) attrs[node.attributes[i].name] = node.attributes[i].value;
	        return attrs;
	    }
	    function isSameNodeType(node, vnode) {
	        if (isString(vnode)) return 3 === getNodeType(node);
	        if (isString(vnode.nodeName)) return isNamedNode(node, vnode.nodeName);
	        if (isFunction(vnode.nodeName)) return node._componentConstructor === vnode.nodeName || isFunctionalComponent(vnode); else ;
	    }
	    function isNamedNode(node, nodeName) {
	        return node.normalizedNodeName === nodeName || toLowerCase(node.nodeName) === toLowerCase(nodeName);
	    }
	    function getNodeProps(vnode) {
	        var defaultProps = vnode.nodeName.defaultProps, props = clone(defaultProps || vnode.attributes);
	        if (defaultProps) extend(props, vnode.attributes);
	        if (vnode.children) props.children = vnode.children;
	        return props;
	    }
	    function collectNode(node) {
	        cleanNode(node);
	        var name = toLowerCase(node.nodeName), list = nodes[name];
	        if (list) list.push(node); else nodes[name] = [ node ];
	    }
	    function createNode(nodeName, isSvg) {
	        var name = toLowerCase(nodeName), node = nodes[name] && nodes[name].pop() || (isSvg ? document.createElementNS('http://www.w3.org/2000/svg', nodeName) : document.createElement(nodeName));
	        ensureNodeData(node);
	        node.normalizedNodeName = name;
	        return node;
	    }
	    function cleanNode(node) {
	        removeNode(node);
	        if (1 === getNodeType(node)) {
	            ensureNodeData(node, getRawNodeAttributes(node));
	            node._component = node._componentConstructor = null;
	        }
	    }
	    function flushMounts() {
	        var c;
	        while (c = mounts.pop()) if (c.componentDidMount) c.componentDidMount();
	    }
	    function diff(dom, vnode, context, mountAll, parent, rootComponent, nextSibling) {
	        diffLevel++;
	        var ret = idiff(dom, vnode, context, mountAll, rootComponent);
	        if (parent && ret.parentNode !== parent) parent.insertBefore(ret, nextSibling || null);
	        if (!--diffLevel) flushMounts();
	        return ret;
	    }
	    function idiff(dom, vnode, context, mountAll, rootComponent) {
	        var originalAttributes = vnode && vnode.attributes;
	        while (isFunctionalComponent(vnode)) vnode = buildFunctionalComponent(vnode, context);
	        if (empty(vnode)) {
	            vnode = '';
	            if (rootComponent) {
	                if (dom) {
	                    if (8 === dom.nodeType) return dom;
	                    collectNode(dom);
	                }
	                return document.createComment(vnode);
	            }
	        }
	        if (isString(vnode)) {
	            if (dom) {
	                if (3 === getNodeType(dom) && dom.parentNode) {
	                    dom.nodeValue = vnode;
	                    return dom;
	                }
	                collectNode(dom);
	            }
	            return document.createTextNode(vnode);
	        }
	        var svgMode, out = dom, nodeName = vnode.nodeName;
	        if (isFunction(nodeName)) return buildComponentFromVNode(dom, vnode, context, mountAll);
	        if (!isString(nodeName)) nodeName = String(nodeName);
	        svgMode = 'svg' === toLowerCase(nodeName);
	        if (svgMode) isSvgMode = !0;
	        if (!dom) out = createNode(nodeName, isSvgMode); else if (!isNamedNode(dom, nodeName)) {
	            out = createNode(nodeName, isSvgMode);
	            while (dom.firstChild) out.appendChild(dom.firstChild);
	            recollectNodeTree(dom);
	        }
	        if (vnode.children && 1 === vnode.children.length && 'string' == typeof vnode.children[0] && 1 === out.childNodes.length && out.firstChild instanceof Text) out.firstChild.nodeValue = vnode.children[0]; else if (vnode.children || out.firstChild) innerDiffNode(out, vnode.children, context, mountAll);
	        diffAttributes(out, vnode.attributes);
	        if (originalAttributes && originalAttributes.ref) (out[ATTR_KEY].ref = originalAttributes.ref)(out);
	        if (svgMode) isSvgMode = !1;
	        return out;
	    }
	    function innerDiffNode(dom, vchildren, context, mountAll) {
	        var j, c, vchild, child, originalChildren = dom.childNodes, children = [], keyed = {}, keyedLen = 0, min = 0, len = originalChildren.length, childrenLen = 0, vlen = vchildren && vchildren.length;
	        if (len) for (var i = 0; i < len; i++) {
	            var _child = originalChildren[i], key = vlen ? (c = _child._component) ? c.__key : (c = _child[ATTR_KEY]) ? c.key : null : null;
	            if (key || 0 === key) {
	                keyedLen++;
	                keyed[key] = _child;
	            } else children[childrenLen++] = _child;
	        }
	        if (vlen) for (var i = 0; i < vlen; i++) {
	            vchild = vchildren[i];
	            child = null;
	            if (keyedLen && vchild.attributes) {
	                var key = vchild.key;
	                if (!empty(key) && key in keyed) {
	                    child = keyed[key];
	                    keyed[key] = void 0;
	                    keyedLen--;
	                }
	            }
	            if (!child && min < childrenLen) for (j = min; j < childrenLen; j++) {
	                c = children[j];
	                if (c && isSameNodeType(c, vchild)) {
	                    child = c;
	                    children[j] = void 0;
	                    if (j === childrenLen - 1) childrenLen--;
	                    if (j === min) min++;
	                    break;
	                }
	            }
	            child = idiff(child, vchild, context, mountAll);
	            if (child !== originalChildren[i]) dom.insertBefore(child, originalChildren[i] || null);
	        }
	        if (keyedLen) for (var i in keyed) if (keyed[i]) children[min = childrenLen++] = keyed[i];
	        if (min < childrenLen) removeOrphanedChildren(children);
	    }
	    function removeOrphanedChildren(children, unmountOnly) {
	        for (var i = children.length; i--; ) {
	            var child = children[i];
	            if (child) recollectNodeTree(child, unmountOnly);
	        }
	    }
	    function recollectNodeTree(node, unmountOnly) {
	        var component = node._component;
	        if (component) unmountComponent(component, !unmountOnly); else {
	            if (node[ATTR_KEY] && node[ATTR_KEY].ref) node[ATTR_KEY].ref(null);
	            if (!unmountOnly) collectNode(node);
	            if (node.childNodes && node.childNodes.length) removeOrphanedChildren(node.childNodes, unmountOnly);
	        }
	    }
	    function diffAttributes(dom, attrs) {
	        var old = dom[ATTR_KEY] || getRawNodeAttributes(dom);
	        for (var _name in old) if (!(attrs && _name in attrs)) setAccessor(dom, _name, null, old[_name], isSvgMode);
	        if (attrs) for (var _name2 in attrs) if (!(_name2 in old) || attrs[_name2] != old[_name2] || ('value' === _name2 || 'checked' === _name2) && attrs[_name2] != dom[_name2]) setAccessor(dom, _name2, attrs[_name2], old[_name2], isSvgMode);
	    }
	    function collectComponent(component) {
	        var name = component.constructor.name, list = components[name];
	        if (list) list.push(component); else components[name] = [ component ];
	    }
	    function createComponent(Ctor, props, context) {
	        var inst = new Ctor(props, context), list = components[Ctor.name];
	        inst.props = props;
	        inst.context = context;
	        if (list) for (var i = list.length; i--; ) if (list[i].constructor === Ctor) {
	            inst.nextBase = list[i].nextBase;
	            list.splice(i, 1);
	            break;
	        }
	        return inst;
	    }
	    function triggerComponentRender(component) {
	        if (!component._dirty) {
	            component._dirty = !0;
	            enqueueRender(component);
	        }
	    }
	    function setComponentProps(component, props, opts, context, mountAll) {
	        var b = component.base;
	        if (!component._disableRendering) {
	            component._disableRendering = !0;
	            if (component.__ref = props.ref) delete props.ref;
	            if (component.__key = props.key) delete props.key;
	            if (empty(b) || mountAll) {
	                if (component.componentWillMount) component.componentWillMount();
	            } else if (component.componentWillReceiveProps) component.componentWillReceiveProps(props, context);
	            if (context && context !== component.context) {
	                if (!component.prevContext) component.prevContext = component.context;
	                component.context = context;
	            }
	            if (!component.prevProps) component.prevProps = component.props;
	            component.props = props;
	            component._disableRendering = !1;
	            if (0 !== opts) if (1 === opts || options.syncComponentUpdates !== !1 || !b) renderComponent(component, 1, mountAll); else triggerComponentRender(component);
	            if (component.__ref) component.__ref(component);
	        }
	    }
	    function renderComponent(component, opts, mountAll) {
	        if (!component._disableRendering) {
	            var skip, rendered, props = component.props, state = component.state, context = component.context, previousProps = component.prevProps || props, previousState = component.prevState || state, previousContext = component.prevContext || context, isUpdate = component.base, initialBase = isUpdate || component.nextBase, baseParent = initialBase && initialBase.parentNode, initialComponent = initialBase && initialBase._component, initialChildComponent = component._component;
	            if (isUpdate) {
	                component.props = previousProps;
	                component.state = previousState;
	                component.context = previousContext;
	                if (2 !== opts && component.shouldComponentUpdate && component.shouldComponentUpdate(props, state, context) === !1) skip = !0; else if (component.componentWillUpdate) component.componentWillUpdate(props, state, context);
	                component.props = props;
	                component.state = state;
	                component.context = context;
	            }
	            component.prevProps = component.prevState = component.prevContext = component.nextBase = null;
	            component._dirty = !1;
	            if (!skip) {
	                if (component.render) rendered = component.render(props, state, context);
	                if (component.getChildContext) context = extend(clone(context), component.getChildContext());
	                while (isFunctionalComponent(rendered)) rendered = buildFunctionalComponent(rendered, context);
	                var toUnmount, base, childComponent = rendered && rendered.nodeName;
	                if (isFunction(childComponent) && childComponent.prototype.render) {
	                    var inst = initialChildComponent, childProps = getNodeProps(rendered);
	                    if (inst && inst.constructor === childComponent) setComponentProps(inst, childProps, 1, context); else {
	                        toUnmount = inst;
	                        inst = createComponent(childComponent, childProps, context);
	                        inst._parentComponent = component;
	                        component._component = inst;
	                        setComponentProps(inst, childProps, 0, context);
	                        renderComponent(inst, 1);
	                    }
	                    base = inst.base;
	                } else {
	                    var cbase = initialBase;
	                    toUnmount = initialChildComponent;
	                    if (toUnmount) cbase = component._component = null;
	                    if (initialBase || 1 === opts) {
	                        if (cbase) cbase._component = null;
	                        base = diff(cbase, rendered, context, mountAll || !isUpdate, baseParent, !0, initialBase && initialBase.nextSibling);
	                    }
	                }
	                if (initialBase && base !== initialBase) if (!toUnmount && initialComponent === component && !initialChildComponent && initialBase.parentNode) {
	                    initialBase._component = null;
	                    recollectNodeTree(initialBase);
	                }
	                if (toUnmount) unmountComponent(toUnmount, !0);
	                component.base = base;
	                if (base) {
	                    var componentRef = component, t = component;
	                    while (t = t._parentComponent) componentRef = t;
	                    base._component = componentRef;
	                    base._componentConstructor = componentRef.constructor;
	                }
	            }
	            if (!isUpdate || mountAll) {
	                mounts.unshift(component);
	                if (!diffLevel) flushMounts();
	            } else if (!skip && component.componentDidUpdate) component.componentDidUpdate(previousProps, previousState, previousContext);
	            var fn, cb = component._renderCallbacks;
	            if (cb) while (fn = cb.pop()) fn.call(component);
	            return rendered;
	        }
	    }
	    function buildComponentFromVNode(dom, vnode, context, mountAll) {
	        var c = dom && dom._component, oldDom = dom, isDirectOwner = c && dom._componentConstructor === vnode.nodeName, isOwner = isDirectOwner, props = getNodeProps(vnode);
	        while (c && !isOwner && (c = c._parentComponent)) isOwner = c.constructor === vnode.nodeName;
	        if (isOwner && (!mountAll || c._component)) {
	            setComponentProps(c, props, 3, context, mountAll);
	            dom = c.base;
	        } else {
	            if (c && !isDirectOwner) {
	                unmountComponent(c, !0);
	                dom = oldDom = null;
	            }
	            c = createComponent(vnode.nodeName, props, context);
	            if (dom && !c.nextBase) c.nextBase = dom;
	            setComponentProps(c, props, 1, context, mountAll);
	            dom = c.base;
	            if (oldDom && dom !== oldDom) {
	                oldDom._component = null;
	                recollectNodeTree(oldDom);
	            }
	        }
	        return dom;
	    }
	    function unmountComponent(component, remove) {
	        var base = component.base;
	        component._disableRendering = !0;
	        if (component.componentWillUnmount) component.componentWillUnmount();
	        component.base = null;
	        var inner = component._component;
	        if (inner) unmountComponent(inner, remove); else if (base) {
	            if (base[ATTR_KEY] && base[ATTR_KEY].ref) base[ATTR_KEY].ref(null);
	            component.nextBase = base;
	            if (remove) {
	                removeNode(base);
	                collectComponent(component);
	            }
	            removeOrphanedChildren(base.childNodes, !remove);
	        }
	        if (component.__ref) component.__ref(null);
	        if (component.componentDidUnmount) component.componentDidUnmount();
	    }
	    function Component(props, context) {
	        this._dirty = !0;
	        this._disableRendering = !1;
	        this.prevState = this.prevProps = this.prevContext = this.base = this.nextBase = this._parentComponent = this._component = this.__ref = this.__key = this._linkedStates = this._renderCallbacks = null;
	        this.context = context;
	        this.props = props;
	        this.state = this.getInitialState && this.getInitialState() || {};
	    }
	    function render(vnode, parent, merge) {
	        return diff(merge, vnode, {}, !1, parent);
	    }
	    var lcCache = {};
	    var toLowerCase = function(s) {
	        return lcCache[s] || (lcCache[s] = s.toLowerCase());
	    };
	    var resolved = 'undefined' != typeof Promise && Promise.resolve();
	    var defer = resolved ? function(f) {
	        resolved.then(f);
	    } : setTimeout;
	    var options = {
	        vnode: empty
	    };
	    var SHARED_TEMP_ARRAY = [];
	    var EMPTY = {};
	    var ATTR_KEY = 'undefined' != typeof Symbol ? Symbol.for('preactattr') : '__preactattr_';
	    var NON_DIMENSION_PROPS = {
	        boxFlex: 1,
	        boxFlexGroup: 1,
	        columnCount: 1,
	        fillOpacity: 1,
	        flex: 1,
	        flexGrow: 1,
	        flexPositive: 1,
	        flexShrink: 1,
	        flexNegative: 1,
	        fontWeight: 1,
	        lineClamp: 1,
	        lineHeight: 1,
	        opacity: 1,
	        order: 1,
	        orphans: 1,
	        strokeOpacity: 1,
	        widows: 1,
	        zIndex: 1,
	        zoom: 1
	    };
	    var items = [];
	    var itemsOffline = [];
	    var nodes = {};
	    var mounts = [];
	    var diffLevel = 0;
	    var isSvgMode = !1;
	    var components = {};
	    extend(Component.prototype, {
	        linkState: function(key, eventPath) {
	            var c = this._linkedStates || (this._linkedStates = {}), cacheKey = key + '|' + eventPath;
	            return c[cacheKey] || (c[cacheKey] = createLinkedState(this, key, eventPath));
	        },
	        setState: function(state, callback) {
	            var s = this.state;
	            if (!this.prevState) this.prevState = clone(s);
	            extend(s, isFunction(state) ? state(s, this.props) : state);
	            if (callback) (this._renderCallbacks = this._renderCallbacks || []).push(callback);
	            triggerComponentRender(this);
	        },
	        forceUpdate: function() {
	            renderComponent(this, 2);
	        },
	        render: function() {
	            return null;
	        }
	    });
	    exports.h = h;
	    exports.cloneElement = cloneElement;
	    exports.Component = Component;
	    exports.render = render;
	    exports.rerender = rerender;
	    exports.options = options;
	});
	//# sourceMappingURL=preact.js.map

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var pieces_1 = __webpack_require__(2);
	var state_history_1 = __webpack_require__(9);
	var constantes_1 = __webpack_require__(1);
	var Board = /** @class */ (function () {
	    function Board(state) {
	        var _this = this;
	        if (state === void 0) { state = null; }
	        this._isCheck = false;
	        this._isCheckMate = false;
	        this._isPat = false;
	        this._isWin = false;
	        this._winner = undefined;
	        this._piecesLeft = [0, 0];
	        this._mustPromote = null;
	        this.onStateChange = function (nextState) {
	            console.log('setState');
	            _this._mustPromote = null;
	            // demap old state positions
	            if (_this.state) {
	                _this.state.pieces.forEach(function (p) { return (_this.getSquare(p.x, p.y).piece = null); });
	            }
	            // map new state positions
	            _this._piecesLeft[constantes_1.White] = _this._piecesLeft[constantes_1.Black] = 0;
	            nextState.pieces.forEach(function (p) {
	                _this.getSquare(p.x, p.y).piece = p;
	                _this._piecesLeft[p.color]++;
	                // si on a un pion sur la derniere ligne, il doit être promu
	                if (p.type === pieces_1.Pawn.key && p.y === (p.color === constantes_1.White ? constantes_1.HEIGHT - 1 : 0)) {
	                    _this._mustPromote = p;
	                }
	            });
	            _this.state = nextState;
	            _this._isWin =
	                _this._piecesLeft[constantes_1.White] === 1 || _this._piecesLeft[constantes_1.Black] === 1;
	            _this._winner = _this._isWin
	                ? _this._piecesLeft[constantes_1.White] === 1
	                    ? constantes_1.White
	                    : constantes_1.Black
	                : undefined;
	            _this._isCheck =
	                !_this._isWin &&
	                    testCheck({
	                        whoseKing: _this.state.whoseTurn,
	                        pieces: _this.state.pieces,
	                    });
	            if (!_this._isWin && !_this._mustPromote) {
	                _this.invalidatePossibleMoves();
	            }
	            else {
	                _this.possibleMoves = _this.mandatoryMoves = [];
	            }
	            // TODO maybe dispatch win event
	            // TODO maybe dispatch check event
	            // TODO maybe dispatch promote event
	        };
	        var len = constantes_1.WIDTH * constantes_1.HEIGHT;
	        var x;
	        var y = 0;
	        var color;
	        this.squares = [];
	        for (var i = 0; i < len; i++) {
	            x = i % constantes_1.WIDTH;
	            x === 0 && i > 0 && y++;
	            color = x % 2 === y % 2 ? constantes_1.White : constantes_1.Black;
	            this.squares[i] = { x: x, y: y, color: color, piece: null };
	        }
	        this._history = new state_history_1.StateHistory();
	        this._history.subscribe(this.onStateChange);
	        if (state) {
	            this.setState(state);
	        }
	    }
	    Object.defineProperty(Board.prototype, "isCheck", {
	        get: function () {
	            return this._isCheck;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Board.prototype, "isCheckMate", {
	        get: function () {
	            return this._isCheckMate;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Board.prototype, "isPat", {
	        get: function () {
	            return this._isPat;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Board.prototype, "isWin", {
	        get: function () {
	            return this._isWin;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Board.prototype, "winner", {
	        get: function () {
	            return this._winner;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Board.prototype, "mustBePromoted", {
	        get: function () {
	            return this._mustPromote;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Board.prototype, "history", {
	        get: function () {
	            return this._history;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Board.prototype.setState = function (nextState) {
	        this._history.push(nextState);
	    };
	    Board.prototype.getState = function () {
	        return this.state;
	    };
	    Board.prototype.getPiece = function (x, y) {
	        return this.getSquare(x, y).piece;
	    };
	    Board.prototype.getSquare = function (x, y) {
	        if (x < 0 || x >= constantes_1.WIDTH || y < 0 || y >= constantes_1.HEIGHT) {
	            return null;
	        }
	        return this.squares[x + y * constantes_1.WIDTH];
	    };
	    Board.prototype.move = function (x, y, toX, toY) {
	        console.log('move', { x: x, y: y, toX: toX, toY: toY });
	        if (this._mustPromote) {
	            throw new Error("Can't move because a pawn is awaiting for promotion");
	        }
	        var piece = this.getPiece(x, y);
	        if (!piece) {
	            throw new Error("No piece found in " + x + "," + y);
	        }
	        if (piece.color !== this.state.whoseTurn) {
	            throw new Error("The piece found in " + x + "," + y + " does not belong to the current player");
	        }
	        if (piece.x !== x || piece.y !== y) {
	            throw new Error("Piece position {" + piece.x + "," + piece.y + "} differs from {" + x + "," + y + "}. This should never happen: the state has probably been mutated.");
	        }
	        var legalMoves = this.mandatoryMoves.length
	            ? this.mandatoryMoves
	            : this.possibleMoves;
	        if (!isMoveInList(x, y, toX, toY, legalMoves)) {
	            throw new Error('Illegal move');
	        }
	        // si il y a une piece sur la case d'arrivée, elle est tuée
	        var killed = this.getPiece(toX, toY);
	        if (killed && killed.type === pieces_1.King.key) {
	            throw new Error("King shouldn't get killed");
	        }
	        var curTurn = this.state.turn || 1;
	        this.setState({
	            turn: this.state.whoseTurn === constantes_1.Black ? curTurn + 1 : curTurn,
	            whoseTurn: this.state.whoseTurn === constantes_1.White ? constantes_1.Black : constantes_1.White,
	            pieces: reducePieces(this.state.pieces, piece, __assign({}, piece, { x: toX, y: toY }), killed),
	        });
	        // TODO maybe dispatch move and kill events
	    };
	    Board.prototype.promote = function (newType) {
	        if (newType === void 0) { newType = pieces_1.Queen; }
	        console.log('promote to', newType.key);
	        var piece = this._mustPromote;
	        if (!piece) {
	            throw new Error('No pawn can be promoted right now');
	        }
	        if (!newType.canPromote) {
	            throw new Error('Invalid new piece type for promotion');
	        }
	        this.setState(__assign({}, this.state, { pieces: reducePieces(this.state.pieces, piece, __assign({}, piece, { type: newType.key })) }));
	        // TODO maybe dispatch promoted event
	    };
	    Board.prototype.getLegalMoves = function () {
	        var legalMoves = this.mandatoryMoves.length
	            ? this.mandatoryMoves
	            : this.possibleMoves;
	        // clone moves to be sure user dont mutate them
	        return legalMoves.map(function (m) { return (__assign({}, m)); });
	    };
	    Board.prototype.getLegalMovesFlat = function () {
	        return this.mandatoryMoves.length
	            ? flatMovesList(this.mandatoryMoves)
	            : flatMovesList(this.possibleMoves);
	    };
	    Board.prototype.invalidatePossibleMoves = function () {
	        var _this = this;
	        console.log('invalidate possible moves');
	        this.possibleMoves = [];
	        this.mandatoryMoves = [];
	        /**
	         * on parcours chaque piece du joueur en cours
	         */
	        this.state.pieces.forEach(function (piece) {
	            if (!piece || piece.color !== _this.state.whoseTurn)
	                return;
	            var pieceType = pieces_1.getPieceType(piece.type);
	            var possibleDest = [];
	            var mandatoryDest = [];
	            var from = _this.getSquare(piece.x, piece.y);
	            /**
	             * pour chaque piece on teste tous ses mouvements
	             * et on ne retient que les possibles
	             */
	            pieceType.movements.forEach(function (movement) {
	                return findPossibleDestinations(piece, movement, from, _this.getSquare.bind(_this), function (hypothetic) {
	                    /**
	                     * test if the king will be checked after this move
	                     */
	                    var willCheck = testCheck({
	                        whoseKing: _this.state.whoseTurn,
	                        pieces: reducePieces(_this.state.pieces, piece, __assign({}, piece, { x: hypothetic.x, y: hypothetic.y }), hypothetic.piece),
	                    });
	                    if (hypothetic.piece) {
	                        // case occupée par un ennemi, mouvement obligatoire
	                        // sauf si :
	                        // - aller ici nous mettrait en échec
	                        // - la piece sur la case ciblée est le roi ennemi
	                        // (permet d'empecher de tuer le roi noir dès le premier
	                        // tour si il se trouvait en échec à cause des placements initiaux)
	                        if (!willCheck && hypothetic.piece.type !== pieces_1.King.key) {
	                            mandatoryDest.push(hypothetic);
	                        }
	                        return;
	                    }
	                    // case libre
	                    if (!willCheck)
	                        possibleDest.push(hypothetic);
	                });
	            });
	            if (mandatoryDest.length) {
	                // si cette pièce a des mouvements obligatoires, on les enregistre
	                _this.mandatoryMoves.push({
	                    from: from,
	                    to: mandatoryDest,
	                });
	            }
	            else if (possibleDest.length) {
	                // si elle n'a pas de mouvement obligatoire, on enregistre les mouvements possibles
	                _this.possibleMoves.push({
	                    from: from,
	                    to: possibleDest,
	                });
	            }
	        });
	        var noLegalMove = this.mandatoryMoves.length === 0 && this.possibleMoves.length === 0;
	        this._isCheckMate = noLegalMove && this._isCheck;
	        this._isPat = noLegalMove && !this._isCheck;
	        // TODO maybe dispatch an event if checkMate or pat
	    };
	    Board.prototype.destroy = function () {
	        this._history.unsubscribe(this.onStateChange);
	    };
	    return Board;
	}());
	exports.default = Board;
	function isMoveInList(x, y, toX, toY, list) {
	    return list.some(function (moves) {
	        if (moves.from.x === x && moves.from.y === y) {
	            return moves.to.some(function (dest) {
	                return dest.x === toX && dest.y === toY;
	            });
	        }
	        return false;
	    });
	}
	function flatMovesList(list) {
	    var out = [];
	    list.forEach(function (moves) {
	        moves.to.forEach(function (dest) {
	            return out.push({ x: moves.from.x, y: moves.from.y, toX: dest.x, toY: dest.y });
	        });
	    });
	    return out;
	}
	/**
	 * retourne une copie du tableau `pieces`
	 * en remplaçant `piece` par `newState`
	 * et en supprimant `remove` de la liste
	 * @param pieces
	 * @param piece
	 * @param newState
	 * @param remove
	 */
	function reducePieces(pieces, piece, newState, remove) {
	    if (remove === void 0) { remove = null; }
	    return pieces.reduce(function (acc, p) {
	        if (p === piece) {
	            // si c'est la piece dont il faut modifier la position
	            acc.push(newState);
	        }
	        else if (p !== remove) {
	            // on retire de la liste la piece tuée
	            acc.push(p);
	        }
	        return acc;
	    }, []);
	}
	/**
	 * used to create a virtual board for check test
	 * @param squares
	 * @param x
	 * @param y
	 */
	function getOrCreateSquare(squares, x, y) {
	    if (x < 0 || x >= constantes_1.WIDTH || y < 0 || y >= constantes_1.HEIGHT) {
	        return null;
	    }
	    return (squares[x + y * constantes_1.WIDTH] ||
	        (squares[x + y * constantes_1.WIDTH] = {
	            x: x,
	            y: y,
	            piece: null,
	            color: null,
	        }));
	}
	/**
	 * test if the king can be killed by an opponent
	 * @param state
	 */
	function testCheck(state) {
	    var squares = [];
	    var whoseKing = state.whoseKing, pieces = state.pieces;
	    var getSquare = function (x, y) { return getOrCreateSquare(squares, x, y); };
	    var what = pieces
	        .filter(function (piece, i) {
	        getOrCreateSquare(squares, piece.x, piece.y).piece = piece;
	        return piece.color !== whoseKing;
	    })
	        .some(function (piece) {
	        // apply piece movements
	        var pieceType = pieces_1.getPieceType(piece.type);
	        var from = getOrCreateSquare(squares, piece.x, piece.y);
	        return pieceType.movements.some(function (movement) {
	            return findPossibleDestinations(piece, movement, from, getSquare, function (hypothetic) {
	                if (hypothetic.piece &&
	                    hypothetic.piece.type === pieces_1.King.key &&
	                    hypothetic.piece.color === whoseKing) {
	                    return true;
	                }
	            });
	        });
	    });
	    return what;
	}
	exports.testCheck = testCheck;
	/**
	 * appelle `callback` sur chaque case où ce mouvement permet d'aller
	 *
	 * si `callback` retourne autre chose que `undefined`,
	 * cette fonction s'arrête de tenter de répeter le mouvement et retourne
	 * la valeur retournée par `callback`
	 *
	 * @param piece
	 * @param movement
	 * @param from
	 * @param getSquare
	 * @param callback
	 */
	function findPossibleDestinations(piece, movement, from, getSquare, callback) {
	    // multiplicateur des mouvements selon le côté du joueur
	    // 1 pour le joueur du bas (blanc) et -1 pour le joueur du haut (noir)
	    var sideMult = piece.color === constantes_1.White ? 1 : -1;
	    var repeat = 0;
	    var hypothetic = from;
	    var x;
	    var y;
	    // tant que le mouvement peut être répété
	    while (repeat < movement.repeat) {
	        x = hypothetic.x + movement.x * sideMult;
	        y = hypothetic.y + movement.y * sideMult;
	        hypothetic = getSquare(x, y);
	        if (
	        // si la case existe
	        hypothetic &&
	            // et qu'elle est vide ou occupée par un ennemi
	            (hypothetic.piece === null || hypothetic.piece.color !== piece.color) &&
	            // et que la condition du movement est remplie
	            (movement.condition === null ||
	                movement.condition(from, hypothetic, repeat, getSquare))) {
	            var r = callback(hypothetic);
	            if (r !== undefined)
	                return r;
	            if (hypothetic.piece) {
	                // si case occupée, on quitte car on ne pourra pas aller plus loin
	                return;
	            }
	            // la case est libre, on repete pour trouver des cases libres plus loin
	            repeat++;
	        }
	        else {
	            // si la case n'existe pas
	            // ou est occupée par un allié
	            // ou la condition du mouvement ne permet pas d'y aller
	            return;
	        }
	    }
	}


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(10);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Board_1 = __webpack_require__(4);
	var pieces_1 = __webpack_require__(2);
	var constantes_1 = __webpack_require__(1);
	var virtualBoard = new Board_1.default();
	virtualBoard.history.maxLength = 0;
	var AI = /** @class */ (function () {
	    function AI(board, color, delay) {
	        var _this = this;
	        if (delay === void 0) { delay = 0; }
	        this.onHistoryChange = function (state) {
	            if (!_this.board.mustBePromoted && state.whoseTurn === _this.color) {
	                // si c'est à l'IA de jouer
	                _this.move(state);
	            }
	            else if (_this.board.mustBePromoted &&
	                _this.board.mustBePromoted.color === _this.color) {
	                // si l'IA doit promouvoir un pion
	                _this.promote(state);
	            }
	        };
	        this.board = board;
	        this.color = color;
	        this.delay = delay;
	        this.board.history.subscribe(this.onHistoryChange);
	        var state = this.board.getState();
	        if (state)
	            this.onHistoryChange(state);
	    }
	    AI.prototype.move = function (state) {
	        var _this = this;
	        console.log('AI find best move...');
	        var numPieces = 0;
	        var numEnnemies = 0;
	        state.pieces.forEach(function (piece) {
	            if (piece.color === _this.color) {
	                numPieces++;
	            }
	            else {
	                numEnnemies++;
	            }
	        });
	        var moves = this.board.getLegalMovesFlat();
	        var bestMove = null;
	        var bestScore = -Infinity;
	        moves.forEach(function (move) {
	            virtualBoard.setState(state);
	            var piece = virtualBoard.getPiece(move.x, move.y);
	            virtualBoard.move(move.x, move.y, move.toX, move.toY);
	            var ennemyMoves = virtualBoard.getLegalMovesFlat();
	            var mustKill = ennemyMoves.length &&
	                !!virtualBoard.getPiece(ennemyMoves[0].toX, ennemyMoves[0].toY);
	            var score = 100;
	            if (mustKill) {
	                score += 100;
	            }
	            if (numEnnemies > 6) {
	                score -= ennemyMoves.length;
	            }
	            if (numPieces <= 6 && piece.type === pieces_1.King.key) {
	                score -= 50;
	            }
	            if (piece.type === pieces_1.Pawn.key) {
	                score += piece.color === constantes_1.White ? piece.y : constantes_1.HEIGHT - piece.y - 1;
	            }
	            var newState = virtualBoard.getState();
	            var willNeedToKill = false;
	            var minNumPossibleMoves = Infinity;
	            ennemyMoves.forEach(function (move) {
	                virtualBoard.setState(newState);
	                virtualBoard.move(move.x, move.y, move.toX, move.toY);
	                if (virtualBoard.mustBePromoted) {
	                    virtualBoard.promote();
	                }
	                var possibleMoves = virtualBoard.getLegalMovesFlat();
	                if (possibleMoves.length < minNumPossibleMoves) {
	                    minNumPossibleMoves = possibleMoves.length;
	                }
	                willNeedToKill = possibleMoves.some(function (myMove) {
	                    if (virtualBoard.getPiece(myMove.toX, myMove.toY)) {
	                        return true;
	                    }
	                });
	            });
	            score += minNumPossibleMoves;
	            if (willNeedToKill) {
	                score -= 50;
	            }
	            if (score >= bestScore) {
	                bestMove = move;
	                bestScore = score;
	            }
	        });
	        if (bestMove) {
	            this.delayAction(function () {
	                return _this.board.move(bestMove.x, bestMove.y, bestMove.toX, bestMove.toY);
	            });
	        }
	        console.log('AI found best move:', bestMove, bestScore);
	    };
	    AI.prototype.promote = function (state) {
	        console.log('AI find best promote');
	        var toPromote = this.board.mustBePromoted;
	        var bestType;
	        var bestScore = -Infinity;
	        Object.keys(pieces_1.types).forEach(function (key) {
	            var type = pieces_1.types[key];
	            if (type.canPromote) {
	                var score = 100;
	                virtualBoard.setState(state);
	                virtualBoard.promote(type);
	                var newState_1 = virtualBoard.getState();
	                var ennemyMoves = virtualBoard.getLegalMovesFlat();
	                var willNeedToKill_1 = false;
	                var minNumPossibleMoves_1 = Infinity;
	                ennemyMoves.forEach(function (move) {
	                    virtualBoard.setState(newState_1);
	                    virtualBoard.move(move.x, move.y, move.toX, move.toY);
	                    if (virtualBoard.mustBePromoted) {
	                        virtualBoard.promote();
	                    }
	                    var possibleMoves = virtualBoard.getLegalMovesFlat();
	                    if (possibleMoves.length < minNumPossibleMoves_1) {
	                        minNumPossibleMoves_1 = possibleMoves.length;
	                    }
	                    possibleMoves.forEach(function (myMove) {
	                        if (myMove.x === toPromote.x &&
	                            myMove.y === toPromote.y &&
	                            virtualBoard.getPiece(myMove.toX, myMove.toY)) {
	                            willNeedToKill_1 = true;
	                        }
	                    });
	                });
	                score += minNumPossibleMoves_1;
	                if (willNeedToKill_1) {
	                    score -= 50;
	                }
	                if (score > bestScore) {
	                    bestScore = score;
	                    bestType = type;
	                }
	            }
	        });
	        console.log('AI found best promote:', bestType.key, bestScore);
	        this.board.promote(bestType);
	    };
	    AI.prototype.delayAction = function (fn) {
	        clearTimeout(this.actionTimeout);
	        this.actionTimeout = setTimeout(fn, this.delay);
	    };
	    AI.prototype.destroy = function () {
	        clearTimeout(this.actionTimeout);
	        this.board.history.unsubscribe(this.onHistoryChange);
	        this.board = null;
	    };
	    return AI;
	}());
	exports.default = AI;


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Board_1 = __webpack_require__(4);
	exports.Board = Board_1.default;
	exports.testCheck = Board_1.testCheck;
	var state_1 = __webpack_require__(8);
	exports.getDefaultBoardState = state_1.default;
	exports.getRandomBoardState = state_1.getRandomBoardState;
	var pieces_1 = __webpack_require__(2);
	exports.registerPieceType = pieces_1.registerPieceType;
	exports.getPieceType = pieces_1.getPieceType;
	exports.King = pieces_1.King;
	exports.Queen = pieces_1.Queen;
	exports.Bishop = pieces_1.Bishop;
	exports.Knight = pieces_1.Knight;
	exports.Rook = pieces_1.Rook;
	exports.Pawn = pieces_1.Pawn;
	var constantes_1 = __webpack_require__(1);
	exports.White = constantes_1.White;
	exports.Black = constantes_1.Black;
	exports.WIDTH = constantes_1.WIDTH;
	exports.HEIGHT = constantes_1.HEIGHT;
	var AI_1 = __webpack_require__(6);
	exports.AI = AI_1.default;


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var constantes_1 = __webpack_require__(1);
	var pieces_1 = __webpack_require__(2);
	function getDefaultBoardState() {
	    var botColor = constantes_1.White;
	    var topColor = constantes_1.Black;
	    return {
	        whoseTurn: constantes_1.White,
	        pieces: [
	            /**
	             * bottom
	             */
	            {
	                type: pieces_1.Rook.key,
	                x: 0,
	                y: 0,
	                color: botColor,
	            },
	            {
	                type: pieces_1.Knight.key,
	                x: 1,
	                y: 0,
	                color: botColor,
	            },
	            {
	                type: pieces_1.Bishop.key,
	                x: 2,
	                y: 0,
	                color: botColor,
	            },
	            {
	                type: botColor === constantes_1.White ? pieces_1.King.key : pieces_1.Queen.key,
	                x: 3,
	                y: 0,
	                color: botColor,
	            },
	            {
	                type: botColor === constantes_1.White ? pieces_1.Queen.key : pieces_1.King.key,
	                x: 4,
	                y: 0,
	                color: botColor,
	            },
	            {
	                type: pieces_1.Bishop.key,
	                x: 5,
	                y: 0,
	                color: botColor,
	            },
	            {
	                type: pieces_1.Knight.key,
	                x: 6,
	                y: 0,
	                color: botColor,
	            },
	            {
	                type: pieces_1.Rook.key,
	                x: 7,
	                y: 0,
	                color: botColor,
	            },
	            {
	                type: pieces_1.Pawn.key,
	                x: 0,
	                y: 1,
	                color: botColor,
	            },
	            {
	                type: pieces_1.Pawn.key,
	                x: 1,
	                y: 1,
	                color: botColor,
	            },
	            {
	                type: pieces_1.Pawn.key,
	                x: 2,
	                y: 1,
	                color: botColor,
	            },
	            {
	                type: pieces_1.Pawn.key,
	                x: 3,
	                y: 1,
	                color: botColor,
	            },
	            {
	                type: pieces_1.Pawn.key,
	                x: 4,
	                y: 1,
	                color: botColor,
	            },
	            {
	                type: pieces_1.Pawn.key,
	                x: 5,
	                y: 1,
	                color: botColor,
	            },
	            {
	                type: pieces_1.Pawn.key,
	                x: 6,
	                y: 1,
	                color: botColor,
	            },
	            {
	                type: pieces_1.Pawn.key,
	                x: 7,
	                y: 1,
	                color: botColor,
	            },
	            /**
	             * top
	             */
	            {
	                type: pieces_1.Rook.key,
	                x: 0,
	                y: 7,
	                color: topColor,
	            },
	            {
	                type: pieces_1.Knight.key,
	                x: 1,
	                y: 7,
	                color: topColor,
	            },
	            {
	                type: pieces_1.Bishop.key,
	                x: 2,
	                y: 7,
	                color: topColor,
	            },
	            {
	                type: botColor === constantes_1.White ? pieces_1.King.key : pieces_1.Queen.key,
	                x: 3,
	                y: 7,
	                color: topColor,
	            },
	            {
	                type: botColor === constantes_1.White ? pieces_1.Queen.key : pieces_1.King.key,
	                x: 4,
	                y: 7,
	                color: topColor,
	            },
	            {
	                type: pieces_1.Bishop.key,
	                x: 5,
	                y: 7,
	                color: topColor,
	            },
	            {
	                type: pieces_1.Knight.key,
	                x: 6,
	                y: 7,
	                color: topColor,
	            },
	            {
	                type: pieces_1.Rook.key,
	                x: 7,
	                y: 7,
	                color: topColor,
	            },
	            {
	                type: pieces_1.Pawn.key,
	                x: 0,
	                y: 6,
	                color: topColor,
	            },
	            {
	                type: pieces_1.Pawn.key,
	                x: 1,
	                y: 6,
	                color: topColor,
	            },
	            {
	                type: pieces_1.Pawn.key,
	                x: 2,
	                y: 6,
	                color: topColor,
	            },
	            {
	                type: pieces_1.Pawn.key,
	                x: 3,
	                y: 6,
	                color: topColor,
	            },
	            {
	                type: pieces_1.Pawn.key,
	                x: 4,
	                y: 6,
	                color: topColor,
	            },
	            {
	                type: pieces_1.Pawn.key,
	                x: 5,
	                y: 6,
	                color: topColor,
	            },
	            {
	                type: pieces_1.Pawn.key,
	                x: 6,
	                y: 6,
	                color: topColor,
	            },
	            {
	                type: pieces_1.Pawn.key,
	                x: 7,
	                y: 6,
	                color: topColor,
	            },
	        ],
	    };
	}
	exports.default = getDefaultBoardState;
	function getRandomBoardState() {
	    var state = getDefaultBoardState();
	    // on place les pieces aléatoirement
	    state.pieces.forEach(function (piece) {
	        var newPos = getRandomPos(piece);
	        moveAndSwap(piece, newPos.x, newPos.y, state.pieces);
	    });
	    // on vérifie que les 2 fous d'un même joueur
	    // ne sont pas sur une case de même couleur
	    var whiteBishop = -1;
	    var blackBishop = -1;
	    state.pieces.forEach(function (piece) {
	        if (piece.type === pieces_1.Bishop.key) {
	            var color = piece.x % 2 === piece.y % 2 ? 0 : 1;
	            var matesColor = piece.color === constantes_1.White ? whiteBishop : blackBishop;
	            if (color === matesColor) {
	                // les 2 fous sont sur une case de même couleur, on décale le 2e d'une case
	                moveAndSwap(piece, (piece.x + 1) % constantes_1.WIDTH, piece.y, state.pieces);
	            }
	            if (piece.color === constantes_1.White) {
	                whiteBishop = color;
	            }
	            else {
	                blackBishop = color;
	            }
	        }
	    });
	    return state;
	}
	exports.getRandomBoardState = getRandomBoardState;
	function moveAndSwap(piece, x, y, pieces) {
	    var swap = getPieceAt(pieces, x, y);
	    if (swap) {
	        swap.x = piece.x;
	        swap.y = piece.y;
	    }
	    piece.x = x;
	    piece.y = y;
	}
	function getPieceAt(pieces, x, y) {
	    // pieces est de type any parce que TypeScript ne semble pas être au courant que Array.find existe depuis 150 ans
	    return pieces.find(function (piece) { return piece.x === x && piece.y === y; });
	}
	function getRandomPos(piece) {
	    var out = {
	        x: Math.floor(Math.random() * constantes_1.WIDTH),
	        y: Math.floor(Math.random() * 3),
	    };
	    if (piece.color === constantes_1.Black) {
	        out.y = constantes_1.HEIGHT - 1 - out.y;
	    }
	    return out;
	}


/***/ },
/* 9 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var StateHistory = /** @class */ (function () {
	    /**
	     * create a new StateHistory
	     * @param maxLength maximum number of entries that should be stored (default=50)
	     */
	    function StateHistory(maxLength) {
	        if (maxLength === void 0) { maxLength = 50; }
	        this.past = [];
	        this.present = null;
	        this.future = [];
	        this.subscribers = [];
	        this.maxLength = maxLength;
	    }
	    Object.defineProperty(StateHistory.prototype, "numPrev", {
	        get: function () {
	            return this.past.length;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StateHistory.prototype, "numNext", {
	        get: function () {
	            return this.future.length;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    StateHistory.prototype.push = function (state) {
	        if (this.present)
	            this.past.push(this.present);
	        this.present = state;
	        if (this.future.length)
	            this.future = [];
	        if (this.past.length > this.maxLength) {
	            this.past.splice(0, this.past.length - this.maxLength);
	        }
	        this.emit(this.present);
	        return this.present;
	    };
	    StateHistory.prototype.goPrev = function () {
	        // could do go(-1) but this is faster
	        var newPresent = this.past.pop();
	        this.future.splice(0, 0, this.present);
	        this.present = newPresent;
	        this.emit(this.present);
	        return this.present;
	    };
	    StateHistory.prototype.goNext = function () {
	        var newPresent = this.future.shift();
	        this.past.push(this.present);
	        this.present = newPresent;
	        this.emit(this.present);
	        return this.present;
	    };
	    StateHistory.prototype.goLast = function () {
	        var _a;
	        var newPresent = this.future.pop();
	        (_a = this.past).push.apply(_a, this.future);
	        this.present = newPresent;
	        this.emit(this.present);
	        return this.present;
	    };
	    StateHistory.prototype.go = function (i) {
	        if (i === 0) {
	            return this.present;
	        }
	        if (i > 0) {
	            var newPresent = this.future.splice(i - 1, 1)[0];
	            this.past = this.past.concat([this.present], this.future.splice(0, i - 1));
	            this.present = newPresent;
	            this.emit(this.present);
	            return this.present;
	        }
	        else {
	            var start = this.past.length + i;
	            var newPresent = this.past.splice(start, 1)[0];
	            this.future = this.past.splice(start, this.past.length - start).concat([
	                this.present
	            ], this.future);
	            this.present = newPresent;
	            this.emit(this.present);
	            return this.present;
	        }
	    };
	    StateHistory.prototype.get = function (i) {
	        if (i === 0) {
	            return this.present;
	        }
	        if (i > 0) {
	            return this.future[i - 1];
	        }
	        else {
	            return this.past[this.past.length + i];
	        }
	    };
	    StateHistory.prototype.subscribe = function (callback) {
	        this.subscribers.push(callback);
	    };
	    StateHistory.prototype.unsubscribe = function (callback) {
	        var index = this.subscribers.indexOf(callback);
	        if (~index) {
	            this.subscribers.splice(index, 1);
	        }
	    };
	    StateHistory.prototype.unsubscribeAll = function () {
	        this.subscribers.length = 0;
	    };
	    StateHistory.prototype.emit = function (state) {
	        this.subscribers.forEach(function (callback) { return callback(state); });
	    };
	    return StateHistory;
	}());
	exports.StateHistory = StateHistory;


/***/ },
/* 10 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__(3);
	
	var _Game = __webpack_require__(12);
	
	var _Game2 = _interopRequireDefault(_Game);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = (0, _preact.h)(_Game2.default, null);
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
	  }
	
	  _createClass(App, [{
	    key: 'render',
	    value: function render() {
	      return _ref;
	    }
	  }]);
	
	  return App;
	}(_preact.Component);
	
	exports.default = App;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__(3);
	
	var _brchessCore = __webpack_require__(7);
	
	var Chess = _interopRequireWildcard(_brchessCore);
	
	var _renderPiece = __webpack_require__(14);
	
	var _renderPiece2 = _interopRequireDefault(_renderPiece);
	
	__webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var times = function times(num) {
	  return function (fn) {
	    var arr = [];
	    for (var i = 0; i < num; i++) {
	      arr.push(fn(i));
	    }
	    return arr;
	  };
	};
	
	var getKey = function getKey(x, y) {
	  return '' + x + y;
	};
	
	var white = 0;
	
	var Game = function (_Component) {
	  _inherits(Game, _Component);
	
	  function Game() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Game);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Game.__proto__ || Object.getPrototypeOf(Game)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selected: null,
	      p2bot: false,
	      inverse: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Game, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      this.board = new Chess.Board(Chess.getRandomBoardState());
	      this.board.history.subscribe(function () {
	        return _this2.setState();
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.board.destroy();
	      this.board = null;
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      if (nextState.p2bot && !this.state.p2bot) {
	        this.ai = new Chess.AI(this.board, nextState.inverse ? Chess.White : Chess.Black, 500);
	        // this.ai2 = new Chess.AI(this.board, Chess.White, 50);
	      } else if (!nextState.p2bot && this.state.p2bot) {
	        this.ai.destroy();
	        this.ai = null;
	        // this.ai2.destroy();
	        // this.ai2 = null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          selected = _state.selected,
	          p2bot = _state.p2bot,
	          inverse = _state.inverse;
	
	      var boardState = this.board.getState();
	      console.log({ selected: selected });
	
	      var _board = this.board,
	          isCheck = _board.isCheck,
	          isCheckMate = _board.isCheckMate,
	          isPat = _board.isPat,
	          isWin = _board.isWin,
	          winner = _board.winner;
	
	      console.log({ isCheck: isCheck, isCheckMate: isCheckMate, isPat: isPat, isWin: isWin, winner: winner });
	
	      var allowedMoves = this.board.getLegalMoves();
	
	      console.log('BOARD STATE', boardState);
	
	      var currentSelectedIsMovable = false;
	      var highlight = allowedMoves.reduce(function (acc, move) {
	        acc[getKey(move.from.x, move.from.y)] = 'movable';
	        if (selected && selected.x === move.from.x && selected.y === move.from.y) {
	          currentSelectedIsMovable = true;
	          move.to.forEach(function (dest) {
	            acc[getKey(dest.x, dest.y)] = 'dest';
	          });
	        }
	        return acc;
	      }, {});
	
	      var toPromote = this.board.mustBePromoted;
	
	      return (0, _preact.h)(
	        'div',
	        null,
	        (0, _preact.h)(
	          'p',
	          null,
	          (0, _preact.h)(
	            'label',
	            null,
	            (0, _preact.h)('input', {
	              type: 'checkbox',
	              checked: p2bot,
	              onChange: function onChange(e) {
	                return _this3.setState({ p2bot: e.target.checked });
	              }
	            }),
	            ' ',
	            'Joueur 2 auto play'
	          )
	        ),
	        (0, _preact.h)(
	          'p',
	          null,
	          (0, _preact.h)(
	            'label',
	            null,
	            (0, _preact.h)('input', {
	              type: 'checkbox',
	              checked: inverse,
	              onChange: function onChange(e) {
	                return _this3.setState({ inverse: e.target.checked });
	              }
	            }),
	            ' ',
	            'Changer de c\xF4t\xE9'
	          )
	        ),
	        (0, _preact.h)(
	          'p',
	          null,
	          'Joueur 1 :',
	          ' ',
	          boardState.pieces.filter(function (piece) {
	            return piece.color === Chess.White;
	          }).map(function (piece) {
	            return (0, _renderPiece2.default)(piece);
	          })
	        ),
	        (0, _preact.h)(
	          'p',
	          null,
	          'Joueur 2 :',
	          ' ',
	          boardState.pieces.filter(function (piece) {
	            return piece.color === Chess.Black;
	          }).map(function (piece) {
	            return (0, _renderPiece2.default)(piece);
	          })
	        ),
	        toPromote ? (0, _preact.h)(
	          'div',
	          null,
	          (0, _preact.h)(
	            'p',
	            null,
	            'Le pion du joueur',
	            toPromote.color === Chess.White ? 'Blanc' : 'Noir',
	            ' doit \xEAtre promu :',
	            ' ',
	            [Chess.Queen, Chess.Bishop, Chess.Knight, Chess.Rook].map(function (pieceType) {
	              return (0, _preact.h)(
	                'button',
	                {
	                  onClick: function onClick() {
	                    _this3.board.promote(pieceType);
	                    _this3.setState({});
	                  }
	                },
	                (0, _renderPiece2.default)(_extends({}, toPromote, { type: pieceType.key }))
	              );
	            })
	          )
	        ) : null,
	        (0, _preact.h)(
	          'table',
	          null,
	          times(9)(function (i) {
	            return (0, _preact.h)(
	              'tr',
	              null,
	              times(9)(function (j) {
	                var x = inverse ? Chess.WIDTH - j - 1 : j - 1;
	                var y = inverse ? i - 1 : Chess.HEIGHT - i - 1;
	                var key = getKey(x, y);
	                if (x === -1) {
	                  return y === -1 ? (0, _preact.h)('th', { key: key }) : (0, _preact.h)(
	                    'th',
	                    { key: key },
	                    y + 1
	                  );
	                } else if (y === -1) {
	                  return (0, _preact.h)(
	                    'th',
	                    { key: key },
	                    String.fromCharCode(x + 1 + 96).toUpperCase()
	                  );
	                } else {
	                  var square = _this3.board.getSquare(x, y);
	                  var piece = square.piece;
	                  return (0, _preact.h)(
	                    'td',
	                    {
	                      key: key,
	                      'class': (square.color === white ? 'white' : 'black') + ' ' + (highlight[key] || ''),
	                      onClick: function onClick() {
	                        if (currentSelectedIsMovable && highlight[key] === 'dest' && (!p2bot || selected.color === (inverse ? Chess.Black : Chess.White))) {
	                          return _this3.board.move(selected.x, selected.y, x, y);
	                        }
	                        _this3.setState({
	                          selected: piece
	                        });
	                      }
	                    },
	                    piece ? (0, _renderPiece2.default)(piece) : null
	                  );
	                }
	              })
	            );
	          })
	        ),
	        (0, _preact.h)(
	          'p',
	          null,
	          'Tour ',
	          boardState.turn || 1,
	          ' - Joueur',
	          ' ',
	          boardState.whoseTurn === Chess.White ? 'Blanc' : 'Noir'
	        ),
	        isCheck || isPat || isWin ? (0, _preact.h)(
	          'p',
	          null,
	          isCheckMate ? 'Échec et mat' : isCheck ? 'Échec au roi' : isPat ? 'Pat' : isWin ? 'Gagnant : joueur ' + (winner === Chess.White ? 'Blanc' : 'Noir') : ''
	        ) : null,
	        (0, _preact.h)(
	          'div',
	          null,
	          (0, _preact.h)(
	            'button',
	            {
	              disabled: this.board.history.numPrev === 0,
	              onClick: function onClick() {
	                _this3.board.history.goPrev();
	                _this3.setState({ selected: null, p2bot: false });
	              }
	            },
	            'PREV'
	          ),
	          (0, _preact.h)(
	            'button',
	            {
	              disabled: this.board.history.numNext === 0,
	              onClick: function onClick() {
	                _this3.board.history.goNext();
	                _this3.setState({ selected: null, p2bot: false });
	              }
	            },
	            'NEXT'
	          )
	        )
	      );
	    }
	  }]);
	
	  return Game;
	}(_preact.Component);
	
	exports.default = Game;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _preact = __webpack_require__(3);
	
	var _App = __webpack_require__(11);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _preact.render)((0, _preact.h)(_App2.default, null), document.getElementById('root'));

/***/ },
/* 14 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = renderPiece;
	var map = {
	  k: ['♔', '♚'],
	  q: ['♕', '♛'],
	  r: ['♖', '♜'],
	  b: ['♗', '♝'],
	  n: ['♘', '♞'],
	  '': ['♙', '♟']
	};
	
	function renderPiece(piece) {
	  return map[piece.type][piece.color];
	}

/***/ },
/* 15 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 16 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(19).enable();
	  window.Promise = __webpack_require__(18);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(20);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(16);


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(5);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(5);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 20 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    reader.readAsArrayBuffer(blob)
	    return fileReaderReady(reader)
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    reader.readAsText(blob)
	    return fileReaderReady(reader)
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (!body) {
	        this._bodyText = ''
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	        // Only support ArrayBuffers for POST method.
	        // Receiving ArrayBuffers happens via Blobs, instead.
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        return this.blob().then(readBlobAsArrayBuffer)
	      }
	
	      this.text = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text')
	        } else {
	          return Promise.resolve(this._bodyText)
	        }
	      }
	    } else {
	      this.text = function() {
	        var rejected = consumed(this)
	        return rejected ? rejected : Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = input
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this)
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function headers(xhr) {
	    var head = new Headers()
	    var pairs = (xhr.getAllResponseHeaders() || '').trim().split('\n')
	    pairs.forEach(function(header) {
	      var split = header.trim().split(':')
	      var key = split.shift().trim()
	      var value = split.join(':').trim()
	      head.append(key, value)
	    })
	    return head
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = options.statusText
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input
	      } else {
	        request = new Request(input, init)
	      }
	
	      var xhr = new XMLHttpRequest()
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL
	        }
	
	        // Avoid security warnings on getResponseHeader when not allowed by CORS
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL')
	        }
	
	        return
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        }
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** static/js/main.64ca2efb.js
 **/